import { ServiceMethods } from '@/src/infrastructure/Protocol/EmblueService';
import { useEmblue } from '@/src/infrastructure/Protocol/useEmblue';

export const usePlansInformation = () => {
  const [data, , planInformationIsLoading] = useEmblue(ServiceMethods.getPlansInformation);

  return { plans: data?.plans, planInformationIsLoading };
};
